//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

// Reference: https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript

/**
 * @deprecated
 *
 * prefer `copyTextToClipboard`
 */
export default function copyToClipBoard(text: string) {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  document.body.appendChild(textArea);

  textArea.focus();
  textArea.select();

  const result = document.execCommand('copy');

  document.body.removeChild(textArea);

  return result;
}

/**
 * Copies the specified text to the user's clipboard using the Navigator.clipboard API if available,
 * falling back to document.execCommand('copy') if not supported.
 *
 * @param text - The text to be copied to the clipboard.
 * @returns A Promise that resolves when the text is successfully copied with `true` or `false` when an error occurs
 */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(text);
    } else {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }

    return true;
  } catch (error) {
    return false;
  }
}
